import { ConfigStateService, LocalizationService, PermissionService } from '@abp/ng.core';
import { Confirmation, ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TicketDto, TicketKind, TicketsService, TicketStatus } from '@proxy/tickets';
import { mergeMap } from 'rxjs';

@Component({
  selector: 'app-tickets-view',
  templateUrl: './tickets-view.component.html',
  styleUrls: ['./tickets-view.component.scss']
})
export class TicketsViewComponent implements OnInit {
  isLoading: boolean = false;
  tenantHostTask: string;
  tenantExist: boolean = false;
  isTicketsLoading: boolean = false;
  canCompleteTicket: boolean = false;
  isCompleted: boolean = false;

  task: TicketDto;
  form: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private config: ConfigStateService,
    private ticketService: TicketsService,
    private fb: FormBuilder,
    private confirmation: ConfirmationService,
    private toaster: ToasterService,
    private localizationService: LocalizationService,
    private permissionService: PermissionService
  ){

  }
  ngOnInit(): void {
    this.isLoading = true;
  
    this.route.params.subscribe((params) => {
      this.tenantHostTask = params['id'];
      this.getTicketTask();
      this.tenantExist = true;
    })
  }
  buildForm(){
    this.form = this.fb.group({
      name: [this.task.name || ''],
      description: [this.task.description || ''],
    });
  }

  getTicketTask(){
    this.isTicketsLoading = true;

    this.route.params.pipe(
      mergeMap((params) => 
        this.ticketService.get(params['id'])
      )).subscribe((response) => {
        this.task = response;
        this.isTicketsLoading = false;
        this.isTaskListShown();
        this.isCompleted = this.task.status == TicketStatus.Done

        this.buildForm();
        this.isLoading = false;
      })


  }

  isTaskListShown(){
    if(!this.isTicketsLoading && this.task != null)
      return true;
    return false;
  }

  updateTaskStatus(id: string){
    this.confirmation.warn('::Ticket:StatusUpdate:Confirmation', 'AbpAccount::AreYouSure')
      .subscribe(((status) => {
        if(status === Confirmation.Status.confirm){
          this.ticketService.updateTicketStatusByTicketId(id).subscribe({
            complete: () => {
              this.toaster.success(
                this.localizationService.instant("::Ticket:Ticket:UpdateStatus:Success")
            );
            this.isCompleted = true;
            },
            error: () => {
              this.toaster.error(
                this.localizationService.instant("::Ticket:Ticket:UpdateStatus:Error:00001")
              );
            }
          })
        }
      }))
  }
  isAbleToCompleteTask(){
    if(this.task.ticketKind == TicketKind.Ticket && this.permissionService.getGrantedPolicy('Tickets.Tickets.EditStatus') && this.isTaskAssignedToCurrentUser() && !this.isCompleted){
      return true;
    }
    return false;
  }
  isTaskAssignedToCurrentUser(){
    return this.config.getOne("currentUser").id == this.task.assignedUserId;
  }
}
